import { GetRunEventsActionEnum } from "@app/api/generated";

/** i18n key per event action. Keyed by the (structurally identical) request/DTO action enum. */
export const EVENT_ACTION_LABEL_KEY: Record<GetRunEventsActionEnum, string> = {
  [GetRunEventsActionEnum.SET_ONLINE]: "productPageSync.event.action.setOnline",
  [GetRunEventsActionEnum.SET_OFFLINE]: "productPageSync.event.action.setOffline",
  [GetRunEventsActionEnum.START_GRACE]: "productPageSync.event.action.startGrace",
  [GetRunEventsActionEnum.RESET_GRACE]: "productPageSync.event.action.resetGrace",
  [GetRunEventsActionEnum.CREATE]: "productPageSync.event.action.create",
  [GetRunEventsActionEnum.DELETE]: "productPageSync.event.action.delete",
  [GetRunEventsActionEnum.ERROR]: "productPageSync.event.action.error",
  [GetRunEventsActionEnum.RECONCILE]: "productPageSync.event.action.reconcile"
};
